import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { useAssetModalPanel } from "~/components/AssetModalV2/AssetModalPanelsContextProvider";
import { ChaptersPanel } from "~/components/AssetModalV2/Content/Panel/components/ChaptersPanel";
import { PDFOutlinePanel } from "~/components/AssetModalV2/Content/Panel/components/PDFOutlinePanel";
import { PrivateTranscriptPanel } from "~/components/AssetModalV2/Content/Panel/Transcript/PrivateTranscriptPanel";
export const LeftContentPanel = /*#__PURE__*/ memo(()=>{
    const { activeLeftContentPanel } = useAssetModalPanel();
    if (activeLeftContentPanel === "transcript") {
        return /*#__PURE__*/ _jsx(PrivateTranscriptPanel, {});
    }
    if (activeLeftContentPanel === "pdfOutline") {
        return /*#__PURE__*/ _jsx(PDFOutlinePanel, {});
    }
    if (activeLeftContentPanel === "chapters") {
        return /*#__PURE__*/ _jsx(ChaptersPanel, {});
    }
    return /*#__PURE__*/ _jsx("div", {
        children: "LeftContentPanel"
    });
});
LeftContentPanel.displayName = "LeftContentPanel";
